module.exports = "/_next/static/images/0cd60a73f62ce139a5b055333377ceec-icon_parachute_heart.png.webp";